import { strings } from '@/shared/strings';
import { ConfirmSheet } from '@/ui/primitives/ConfirmSheet';
import { modalStyles } from '@/ui/primitives/Modal';

export interface PurgeCaseDialogProps {
  jobOrderNo: string;
  busy: boolean;
  /** The server's refusal, shown where the choice was made. */
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * The approval before a case is deleted for good. Request of 24 September 2026:
 * "add an option to permanently delete a case. Before this ask for approval."
 *
 * A deleted case can be restored for thirty days and is then purged by the
 * night. This is the one action in the system that nothing undoes, so it is
 * never one tap: the question names the case and says that nothing brings it
 * back, the line under it says what goes, and focus opens on the close button,
 * so a stray Enter closes the sheet and deletes nothing.
 *
 * Since the request of 5 October 2026 (third), section 2, it is built on the
 * shared `ConfirmSheet`, as every confirmation is.
 */
export function PurgeCaseDialog({ jobOrderNo, busy, error, onCancel, onConfirm }: PurgeCaseDialogProps) {
  return (
    <ConfirmSheet
      title={`${strings.deletion.purgeTitle} · ${jobOrderNo}`}
      statement={strings.confirm.purgeCase(jobOrderNo)}
      confirmLabel={strings.deletion.purgeConfirm}
      cancelLabel={strings.deletion.cancel}
      closeLabel={strings.sheet.close}
      onConfirm={onConfirm}
      onCancel={onCancel}
      busy={busy}
    >
      <span className={modalStyles.hint}>{strings.deletion.purgeLead}</span>

      {error !== null && (
        <p className={modalStyles.error} role="alert">
          {error}
        </p>
      )}
    </ConfirmSheet>
  );
}
